import PropTypes from "prop-types";
import { Box, Chip, Tooltip } from "@mui/material";
import SdStorageOutlinedIcon from "@mui/icons-material/SdStorageOutlined";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";

import {
  FONT,
  HAIRLINE,
  INK_MUTED,
  INK_SECONDARY,
} from "../../../theme/tokens";

import {
  formatDatasetBytes,
  generationLabel,
  usageLabel,
} from "./datasetDisplay";

export default function DatasetChips({ dataset }) {
  const items = [
    [
      formatDatasetBytes(dataset.measured_bytes),
      `Measured dataset size: ${formatDatasetBytes(dataset.measured_bytes)}`,
      <SdStorageOutlinedIcon key="size" />,
    ],
    [
      generationLabel(dataset),
      generationLabel(dataset),
      <LayersOutlinedIcon key="generation" />,
    ],
    [
      usageLabel(dataset.recorded_usage_count),
      `${usageLabel(dataset.recorded_usage_count)}: recorded workspace and job attachments across all generations.`,
      <BarChartOutlinedIcon key="usage" />,
    ],
  ];
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0.75,
        alignItems: "start",
      }}
    >
      {items.map(([label, tooltip, icon], index) => (
        <Box key={index} sx={{ minWidth: 0, maxWidth: "100%" }}>
          <Tooltip title={tooltip}>
            <Chip
              size="small"
              variant="outlined"
              label={label}
              icon={icon}
              sx={{
                maxWidth: "100%",
                height: 22,
                fontSize: FONT.xs,
                color: INK_SECONDARY,
                borderColor: HAIRLINE,
                "& .MuiChip-icon": { fontSize: 14, color: INK_MUTED },
                "& .MuiChip-label": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              }}
            />
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
}
DatasetChips.propTypes = {
  dataset: PropTypes.object.isRequired,
};
